import { gql } from "@apollo/client";

export const DEDUCTION_FRAGMENT = gql`
  fragment DeductionFields on DeductionType {
    id
    remittanceItemId
    checkNumber
    checkDate
    claimNumber
    invoiceDate
    age
    deductionDate
    deductionNumber
    deductionType
    deductionTypeId
    deductionTypeKey
    deductionSubType
    deductionSubTypeId
    deductionSubTypeKey
    deductionSubTypeHelpText
    distributionCenter
    distributionCenterCode
    glCodeId
    glCode
    poNumber
    purchaserId
    purchaserKey
    purchaser
    period
    amount
    totalAmount
    description
    priorityId
    priorityKey
    priorityName
    isPredictedPriority
    validityId
    validityKey
    validityName
    rcaDescription
    analystUserId
    analystUserFullName
    analystUserAvatar
    isAnalystDeleted
    approverUserId
    approverUserFullName
    approverUserAvatar
    isApproverDeleted
    retailerName
    retailerKey
    reasonCode
    stages {
      stageId
      stageKey
      stageName
      isCurrent
    }
    status {
      statusId
      statusKey
      statusName
      isCurrent
    }
    documents {
      id
      fileName
      fileSize
      createdAt
      updatedAt
      documentType
      documentTypeKey
      fileMimeType
      fileDisplayName
      filePath
      deletable
    }
    rcaIds
    isDisputed
    canDispute
    latestApprovalComments {
      senderId
      senderFullName
      senderAvatar
      isSenderDeleted
      createdAt
      messageId
      contentHtml
      contentJson
    }
    deductionTypeCategory {
      deductionTypeCategoryId
      deductionTypeCategoryKey
      deductionTypeCategoryName
    }
    controls {
      type
      action
    }
    feeBucket
    feeBucketId
    feeBucketLabel
    splitDisplay {
      separator
      chips {
        axis
        label
        value
      }
      headerText
    }
  }
`;
